export const SEARCH_FOR = 'Search/FOR';
export const SEARCH_CLEAR = 'Search/CLEAR';
export const SET_ASSETS_LIST_TYPE = 'ASSETS_LIST_TYPE/SET';
